import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import { formatMonto } from "@/utils";

export const auditoriaColumns = [
  {
    prop: "EventDate",
    label: "Fecha",
    minWidth: 140,
    formatter: DatetimeFormatter
  },
  {
    prop: "EventName",
    label: "Descripcion",
    minWidth: 210
  },
  {
    prop: "status_anterior",
    label: "Status anterior",
    minWidth: 120
  },
  {
    prop: "nuevo_status",
    label: "Nuevo status",
    minWidth: 120
  },
  {
    prop: "balance_anterior",
    label: "Balance anterior",
    minWidth: 150,
    formatter: (row) => formatMonto(row.balance_anterior)
  },
  {
    prop: "nuevo_balance",
    label: "Nuevo balance",
    minWidth: 150,
    formatter: (row) => formatMonto(row.nuevo_balance)
  },
  {
    prop: "asignacion_anterior",
    label: "Asignacion Anterior",
    minWidth: 150,
    formatter: (row) => formatMonto(row.asignacion_anterior)
  },
  {
    prop: "nuevo_asignacion",
    label: "Nuevo Asignacion",
    minWidth: 150,
    formatter: (row) => formatMonto(row.nuevo_asignacion)
  },
  {
    prop: "monto_tope_anterior",
    label: "Monto Tope Anterior",
    minWidth: 160,
    formatter: (row) => formatMonto(row.monto_tope_anterior)
  },
  {
    prop: "nuevo_monto_tope",
    label: "Nuevo Monto Tope",
    minWidth: 150,
    formatter: (row) => formatMonto(row.nuevo_monto_tope)
  },
  {
    prop: "tipoconsumo_anterior",
    label: "Tipoconsumo Anterior ",
    minWidth: 160,
    formatter: (row) => (row.tipoconsumo_anterior == "G" ? "Galones" : "Monto")
  },
  {
    prop: "nuevo_tipoconsumo",
    label: "Nuevo Tipoconsumo ",
    minWidth: 160,
    formatter: (row) => (row.nuevo_tipoconsumo == "G" ? "Galones" : "Monto")
  },
  {
    prop: "controlada_anterior",
    label: "Controlada Anterior ",
    minWidth: 160,
    formatter: (row) =>
      row.controlada_anterior == 0 ? "Abierta" : "Controlada"
  },
  {
    prop: "nuevo_controlada",
    label: "Nuevo Controlada",
    minWidth: 160,
    formatter: (row) => (row.nuevo_controlada == 0 ? "Abierta" : "Controlada")
  }
];
